import { render, staticRenderFns } from "./BillingTabInvoices.vue?vue&type=template&id=9eda661e"
import script from "./BillingTabInvoices.vue?vue&type=script&lang=js"
export * from "./BillingTabInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports